import React, {useState} from "react"
import {Controller, useForm} from "react-hook-form";
import {EditClientActionItems} from "../../../services/coaching.service";
import {Col, notification, Row} from "antd";
import {RoundedCheck} from "../../../../assets/icons/defaultIcons";
import {Form} from "react-bootstrap";
import {checkEmptySpaces, maxLength, Required} from "../../../utils/patterns";
import DescriptionInput from "../../../components/common/description-field/DescriptionField";
import ThemeButton from "../../../components/common/theme-button/ThemeButton";
import {useNavigate, useParams} from "react-router-dom";

export default function EditActionItems({open, close, clientData, setClientData}) {
    let { id } = useParams();
    let navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [renderContent, setRenderContent] = useState(false);
    const [loader,setLoader] = useState(false)
    const {
        handleSubmit,
        reset,
        setValue,
        formState: { errors },
        control,
        clearErrors,
        watch,
    } = useForm({
        mode: "onChange",
    });

    const onSubmit = async (data) => {
        setLoader(true)
        let payload = {
            clientId: clientData.clientId,
            actionItems: data?.action_items,
        };
        try {
            let res = await EditClientActionItems(payload);
            if (res?.data?.data?.status) {
                notification.success({
                    message: "Success",
                    description: res?.data?.data?.message,
                    placement: "topRight",
                    icon: <RoundedCheck />,
                    duration: 2,
                });
                // Update the coach note in the state
                setClientData((prevState) => ({
                    ...prevState,
                    actionItems: payload.actionItems, // Update the coachNote key
                }));
                close(false)
                setLoader(false)
            }
        } catch (error) {
            console.log("ThisIsErr", error);
            console.log("ThisIsErr2", error?.response);

        } finally {
            close(false)
            setLoader(false)
        }
    };
    return(
        <div>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <div className="main_div_client_details">
                    <Row gutter={[16, 16]}>
                        <Col xs={24} lg={24} xl={24} md={24}>
                            <div className="col_1_div">
                                <div className="inner_div_col_1">
                                    <div className="form_div">
                                        {/*<h5>Coach Note</h5>*/}
                                        <div className={"dfields"}>
                                            <Controller
                                                name="action_items"
                                                defaultValue={clientData?.actionItems ? clientData?.actionItems : '' }
                                                control={control}
                                                rules={{
                                                    required: Required,
                                                    maxLength: maxLength(10000),
                                                    validate: checkEmptySpaces,
                                                }}
                                                render={({ field: { name, ...field } }) => (
                                                    <DescriptionInput
                                                        rows={10}
                                                        autoSize={{ minRows: 10, maxRows: 11 }}
                                                        placeholder={"Write your action items here..."}
                                                        label={"Action Items"}
                                                        type={"text"}
                                                        field={field}
                                                        errors={errors.action_items}
                                                        className={"required"}
                                                        defaultValue={clientData?.actionItems ? clientData?.actionItems : '' }
                                                    />
                                                )}
                                            />
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className={"dfields mt-3"}>
                                <ThemeButton
                                    text={"Submit"}
                                    className={"btn-light-lg"}
                                    type={"submit"}
                                    loader={loader}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
            </Form>
        </div>
    )
}